import type { Team } from "../../../../../api/teams";
import { UserRoles } from "../../../../../shared/constants/common.constant";

export const MAX_TEAM_NAME_LENGTH = 150;
export const MAX_DESCRIPTION_LENGTH = 250;
export const MAX_ADD_MEMBERS = 100;
export const NO_LEADING_WHITESPACE_PATTERN = /^\S.*$/;
export const TEAMS_PAGE_SIZE = 10;
export const ALL_TEAMS_LIST_QUERY = { page: 1, limit: 100 };
export const TEAM_ACTIONS_COLUMN_WIDTH = 150;
export const TOOLBAR_CONTROL_HEIGHT_PX = 40;

export const USER_DELETION_IN_PROGRESS_ERROR_TYPE = "UserDeletionInProgress";

export const MEMBER_LIST_ROW_HEIGHT_PX = 44;
export const MEMBER_LIST_VISIBLE_DATA_ROWS = 4;
export const MEMBER_LIST_MAX_HEIGHT_PX =
  MEMBER_LIST_ROW_HEIGHT_PX * (MEMBER_LIST_VISIBLE_DATA_ROWS + 1);
export const SELECTED_MEMBERS_MAX_HEIGHT_PX = 200;

export const TEAM_ROLE_OPTIONS = [
  {
    id: 1,
    name: UserRoles.Admin,
    labelKey: "rolesAndPermissions.roles.admin",
  },
  {
    id: 2,
    name: UserRoles.Manager,
    labelKey: "rolesAndPermissions.roles.manager",
  },
  {
    id: 3,
    name: UserRoles.Analyst,
    labelKey: "rolesAndPermissions.roles.analyst",
  },
  {
    id: 4,
    name: UserRoles.Viewer,
    labelKey: "rolesAndPermissions.roles.viewer",
  },
] as const;

export const isDefaultTeam = (team: Team): boolean => team.isDefault;
